import React from "react";
import {createRoot} from "react-dom/client";
import App from "./App";
import "./resources/scss/animations.css";
import LogRocket from "logrocket";
import {
  sanitizeLogRocket,
  logRocketRequestSanitizer,
  logRocketResponseSanitizer,
  logRocketUrlSanitizer,
} from "./resources/logRocket";
import {Helmet, HelmetProvider} from "react-helmet-async";
import {buildCSP} from "./resources/csp";
import "@fontsource/geist/300.css";
import "@fontsource/geist/400.css";
import "@fontsource/geist/500.css";
import "@fontsource/geist/700.css";
import "@fontsource/oswald/300.css";
import "@fontsource/oswald/400.css";
import "@fontsource/oswald/500.css";
import "@fontsource/oswald/700.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/saira-semi-condensed/300.css";
import "@fontsource/saira-semi-condensed/400.css";
import "@fontsource/saira-semi-condensed/500.css";
import "@fontsource/saira-semi-condensed/600.css";
import "@fontsource/saira-semi-condensed/700.css";

const ENVIRONMENT_NAME = process.env.ENVIRONMENT_NAME;
const isProduction = ENVIRONMENT_NAME === "production";
const logRocketAppId = isProduction ? "cmqc3w/breachrx" : "cmqc3w/breachrx-development";

const isDynatraceSynthetic = /RuxitSynthetic/i.test(navigator.userAgent);
if (ENVIRONMENT_NAME !== "localdev" && !isDynatraceSynthetic) {
  LogRocket.init(logRocketAppId, {
    dom: {
      inputSanitizer: sanitizeLogRocket(isProduction),
      textSanitizer: sanitizeLogRocket(isProduction),
    },
    network: {
      requestSanitizer: sanitizeLogRocket(isProduction) ? logRocketRequestSanitizer : undefined,
      responseSanitizer: sanitizeLogRocket(isProduction) ? logRocketResponseSanitizer : undefined,
    },
    browser: {
      urlSanitizer: sanitizeLogRocket(isProduction) ? logRocketUrlSanitizer : undefined,
    },
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const container = document.getElementById("app");
  if (container) {
    const root = createRoot(container);
    root.render(
      <React.StrictMode>
        <HelmetProvider>
          <Helmet>
            {ENVIRONMENT_NAME !== "localdev" && (
              <meta httpEquiv="Content-Security-Policy" content={buildCSP()} />
            )}
            <meta name="description" content="BreachRx® | Enterprise Incident Response Management" />
            <link rel="icon" href="/cropped-favicon-32x32.png" />
          </Helmet>
          <App />
        </HelmetProvider>
      </React.StrictMode>,
    );
  } else {
    console.error("Root container not found");
  }
});

if (import.meta.hot) {
  import.meta.hot.accept();
}
